import { clsx } from 'clsx';

type CornerBadgeProps = {
  label: string;
  bgColor: string;
  className?: string;
};

export function CornerBadge({
  label,
  bgColor,
  className,
}: Readonly<CornerBadgeProps>) {
  return (
    <div
      className={clsx(
        `top-0 right-0 text-white text-[12px] px-2 ${bgColor}`,
        className
      )}
      style={{ backgroundColor: bgColor }}
    >
      {label}
    </div>
  );
}
